<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import chatApi from "./components/methods";
import urlParams from "./api/urlParams";

export default {
    name: "App",
    created() {
        if (this.$route.query.channelId) {
            let loading = this.$loading({});
            chatApi.initData(loading);
        }
        window.addEventListener("visibilitychange", () => {
            if (!document.hidden) {
                this.$store.dispatch('visibility', true)
                chatApi.readMessage()
            } else {
                this.$store.dispatch('visibility', false)
                console.log('hide')
            }
        });
    },
    mounted() {
        // setTimeout(() => {
        //     this.$i18n.locale = urlParams('locale') || this.$store.state.initData.language || 'zh';
        // }, 500)
    },
    methods: {
        // clickDom(){
        //     this.$store.dispatch("setConfigH5", [
        //         {key: "showModal", value: false},
        //         {
        //             key: "showMenus",
        //             value: false,
        //         },
        //         {key: "showEmoji", value: false},
        //     ]);
        // }
    },
};
</script>

<style>
span[data-w-e-type="attachment"] {
    color: #4988f8;
    cursor: pointer;
    text-decoration: underline;
}

.mint-toast.is-placemiddle {
    z-index: 99999;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    height: 100%;
}

html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
}

.el-drawer.ttb {
    background: transparent;
}

div,
h1,
img,
p,
ul {
    list-style: none;
    padding: 0;
    margin: 0;
    -webkit-user-drag: none;
}

.text_message {
    overflow: auto;
}

.text_message table {
    border-collapse: collapse;
}

.text_message table td,
.text_message table th {
    border: 1px solid #ccc;
    min-width: 50px;
    height: 20px;
}

.text_message table th {
    background-color: #f1f1f1;
}

.text_message p,
.text_message li {
    white-space: pre-wrap;
    /* 保留空格 */
}

.text_message blockquote {
    border-left: 8px solid #d0e5f2;
    padding: 10px 10px;
    margin: 10px 0;
    background-color: #f1f1f1;
}

.text_message code {
    font-family: monospace;
    background-color: #eee;
    padding: 3px;
    border-radius: 3px;
}

.text_message pre>code {
    display: block;
    padding: 10px;
}

.text_message ul,
.text_message ol {
    padding-left: 20px;
}

.text_message input[type="checkbox"] {
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue